import * as React from "react"
const HybridSvg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    x={0}
    y={0}
    style={{
      enableBackground: "new 0 0 290.6 290.6",
    }}
    viewBox="0 0 290.6 290.6"
    {...props}
  >
    <style>{".st0{fill:#70b4c6}.st1{fill:#2d2d2d}"}</style>
    <path
      d="M173.4 98.4h18.8v9.4h-18.8zM210.9 126.6h28.2v103.1H51.6V126.6h103.1v-9.4H42.2v121.9h206.2V117.2h-37.5z"
      className="st0"
    />
    <path d="M173.4 117.2h18.8v9.4h-18.8z" className="st0" />
    <path
      d="M290.6 117.2c0-25.2-17.9-46.3-42.3-50.7-2-37-32.7-66.5-70.2-66.5-25.3 0-48.8 13.9-61.2 35.8-4.3-2-9-3-13.8-3-11.5 0-22.1 6.1-28 15.7-4.6-1.1-9.4-1.7-14.2-1.7-33.6.1-60.9 27.4-60.9 61 0 18.7 8.8 36.3 23.4 47.8V239c0 10.3 8.4 18.7 18.8 18.7h60.9v23.4H84.4v9.4h122v-9.4h-18.8v-23.4h60.9c10.3 0 18.8-8.4 18.8-18.8v-78.8c14.4-9.4 23.3-25.5 23.3-42.9zm-112.5 164h-65.6v-23.4h65.6v23.4zm89.1-132.7v-31.3c0-10.3-8.4-18.8-18.8-18.8h-37.5v9.4h37.5c5.2 0 9.4 4.2 9.4 9.4v121.9c0 5.2-4.2 9.4-9.4 9.4H42.2c-5.2 0-9.4-4.2-9.4-9.4V117.2c0-5.2 4.2-9.4 9.4-9.4h112.5v-9.4H42.2c-10.3 0-18.8 8.4-18.8 18.8V143c-8.9-9.5-14.1-22-14.1-35.2 0-28.4 23.1-51.6 51.6-51.6 5.2 0 10.3.8 15.2 2.3l3.9 1.2 1.7-3.8c3.8-8.4 12.2-13.8 21.3-13.8 4.7 0 9.2 1.4 13.1 4l4.5 3.1 2.3-4.9c10-21.2 31.7-34.9 55-34.9 33.6 0 60.9 27.3 60.9 60.7v4.7l4.2.4c21.7 2.1 38 20.2 38 42 .2 12-5 23.3-13.8 31.3z"
      className="st0"
    />
    <path
      d="M103.1 210.9H75v-75h28.1v75zM140.6 210.9h-28.1v-56.2h28.1v56.2zM178.1 210.9H150V84.4h28.1v126.5zM215.6 210.9h-28.1v-150h28.1v150z"
      className="st1"
    />
    <path d="M65.6 201.6H225v9.4H65.6z" className="st0" />
  </svg>
)
export default HybridSvg